import React, { Component, useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useNavigate, Navigate, Link, useLocation } from "react-router-dom";
import AppContext from "../../AppContext";

import AdminNavbar from "./navbar/AdminNavbar";

//import AdminNavbar from "./navbar/AdminNavbar";

import { MDBIcon, MDBContainer, MDBRow, MDBCol } from "mdb-react-ui-kit";

function AdminLandingPage() {
  const navigate = useNavigate();
  const [navbarPaddingTop, setNavbarPaddingTop] = useState(true);
  const context = useContext(AppContext);
  const [showBasic, setShowBasic] = useState(false);
  const [showBasicSubmenu, setShowBasicSubmenu] = useState(false);
  useEffect(() => {
    if (!context.isLoggedIn()) {
      navigate("/admin/login");
    }
  });

  return (
    <div className="admin-login-page">
      <AdminNavbar />
      <Outlet />
    </div>
  );
}

export default AdminLandingPage;
